import { Controller } from "stimulus";

// Holds a form's submission behind a Block::ConfirmDialogComponent: the button asks, the dialog
// answers, and only a confirm calls requestSubmit(). Used by "End stream" on the live console and
// "Cancel event" on the edit form.
//
// The `confirmation` controller is not an alternative - it wraps window.confirm() and cannot
// drive a dialog component.
export default class extends Controller {
  static targets = ["dialog"];

  requestConfirm() {
    this.dialogController.open();
  }

  onConfirm() {
    this.dialogController.close();
    this.element.requestSubmit();
  }

  onCancel() {
    this.dialogController.close();
  }

  get dialogController() {
    return this.application.getControllerForElementAndIdentifier(this.dialogTarget, "block--confirm-dialog-component");
  }
}
